import { settings } from '../../../settings/settings-util'
import reducer from './reducers/index'
import Renderers from './renderers/renderers'

export default class MinimizeWindow
{
    constructor(passedSettings)
    {
        this._settings = passedSettings || settings;
        this._renderers = new Renderers(this._settings);
    }

    static getDefaultSettings()
    {
        return settings;
    }

    getReducer()
    {
        return reducer;
    }

    getRenderer()
    {
        return this._renderers.getRender();
    }

    getMutator()
    {
        return this._renderers.getMutate();
    }

    initialize(store)
    {
        this._renderers.initialize(store);
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-minimize/src/window-minimize.js